import {BulkImportCase} from "@/components/Case/CaseBulkImport/composables/BulkImportCase";
import {Ref, UnwrapRef} from "vue";
import {AddressImportError} from "@/components/common/types/import";

export type CaseDataRaw = { hodnota: string; druh: string[]; };

type CaseObjectRaw = {
    cj: string;
    id_dok: number;
    datum_zapis: string;
    data: CaseDataRaw[];
    sourceFile: string;
};

type AddressData = {
    cryptos: Set<string>;
    sourceFiles: SourceFiles;
    documents: Set<number>
};

type AddressMap = Map<string, AddressData>;

type CaseMap = Map<string, BulkImportCase>;

type SourceFiles = Set<string>

type SourceFileToInvalidCryptoUnits = Map<string, Set<string>>

type InvalidAddressMap = Map<string, SourceFileToInvalidCryptoUnits>

type FailedAddressMap = Map<string, { sourceFiles: SourceFiles, currencies: Set<string> }>

enum Issue {
    EmptyData = "'data' property is empty",
    InvalidAddress = "Address is invalid",
    UnsupportedCurrencies = "Unsupported currencies",
    IdDokZero = "id_dok is set to 0"
}

type InvalidFile = {
    cj: string,
    name: string,
    issues: string
}

type InvalidFiles = Ref<UnwrapRef<InvalidFile[]>>


enum BulkImportAction {
    AddressImport = "Address Import",
    CaseCreation = "Case Creation",
    CaseUpdate = "Case Update",
    CaseLookup = "Case Lookup"
}

type BulkImportCaseAddresses = { supported: AddressMap, unsupported: AddressMap }

type ImportError = { errors: object, message: string, addresses: { address: string, sourceFiles: SourceFiles}[] }

type AddressImportResult = {totalRequests: number, failedRequestCurrencyToError: Map<string, AddressImportError>}

type CurrencyToImportError = Map<string, ImportError>

type CaseApiCallErrorMessage = string

type CaseApiCallErrors = Map<BulkImportAction, CaseApiCallErrorMessage>

type ApiCallErrorDisplayModel = {
    title: string
    currency: string
    addresses: string[]
    files: string[]
    error: string
    action: BulkImportAction
}

enum AddressSupportStatus {
    Supported = "supported",
    Unsupported = "unsupported"
}

type WarningItem = {
    title: string,
    file: string[],
    address: string,
    issue: Issue
}

export {
    CaseObjectRaw,
    AddressData,
    AddressMap,
    CaseMap,
    SourceFiles,
    InvalidAddressMap,
    FailedAddressMap,
    Issue,
    InvalidFiles,
    BulkImportAction,
    ImportError,
    AddressImportResult,
    CurrencyToImportError,
    CaseApiCallErrorMessage,
    CaseApiCallErrors,
    ApiCallErrorDisplayModel,
    BulkImportCaseAddresses,
    AddressSupportStatus,
    WarningItem,
    SourceFileToInvalidCryptoUnits
}